export const stringFromEnv = (env: string | undefined): string => env || ''

export const msFromSeconds = (seconds: number): number => seconds * 1000
